import React from 'react';
import { Link } from 'react-router-dom';

export default function PetReleaseCard({ id, name, gifUrl, staticUrl, pill = 'Earnable', featured = false }) {
  return (
    <Link
      to={`/catalog/pet/${id}`}
      state={{ bloomFrom: 'release-hero' }}
      className={`release-pet-card${featured ? ' release-pet-card--featured' : ''}`}
      aria-label={`View ${name}`}
    >
      <span className="release-pet-pill">{pill}</span>
      <span className="release-pet-halo" aria-hidden="true" />
      <div className="release-pet-art">
        <img
          src={gifUrl || staticUrl}
          alt={name}
          loading="lazy"
          decoding="async"
          onError={(e) => {
            if (staticUrl && e.currentTarget.src !== window.location.origin + staticUrl) {
              e.currentTarget.src = staticUrl;
            }
          }}
        />
      </div>
      <span className="release-pet-name">{name}</span>
      <span className="release-pet-cta">View pet →</span>
    </Link>
  );
}
